module.exports = require('./helpers/bundle-url').getBundleURL('9p9yL') + "Roboto-Bold.fdb9b54a.ttf";